module.exports = __webpack_public_path__ + "media/honey-icons/icon-left-c618c366.svg";